const stripCrlf = (line) => line.endsWith('\r') ? line.slice(0, -1) : line;
/**
 * Iterate over text lines. Each yielded line has its trailing `//` comment split off
 * and the result trimmed of trailing whitespace.
 */
export function* iterLines(text) {
    const rows = text.split(/\n/);
    for (let i = 0; i < rows.length; i++) {
        const raw = stripCrlf(rows[i]);
        const cIdx = raw.indexOf('//');
        const body = cIdx === -1 ? raw : raw.slice(0, cIdx);
        const comment = cIdx === -1 ? '' : raw.slice(cIdx + 2).trim();
        yield { lineNo: i + 1, raw, trimmed: body.replace(/\s+$/, ''), comment };
    }
}
/**
 * Split a line on whitespace into non-empty tokens.
 */
export function tokens(s) {
    return s.split(/\s+/).filter((t) => t.length > 0);
}
/**
 * Trim ASCII leading whitespace only.
 */
export function lstrip(s) {
    return s.replace(/^[ \t]+/, '');
}
//# sourceMappingURL=lexer.js.map